// @flow
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {SVGIcon} from '@homeaway/react-svg';
import {STAR__16} from '@homeaway/svg-defs';
import type {Node} from 'react';

import './ColorizedRating.less';

type ListingShape = {
    averageRating: number,
    reviewCount: number
};

type Props = {
    listing: ListingShape
};

const ColorizedRating = ({
    listing: {averageRating = 0, reviewCount}
}: Props) => {
    return (
        <Fragment>
            <div className={'Rating'} aria-hidden="true">
                <SVGIcon
                    className={`Rating__star ${averageRating && 'filled'}`}
                    markup={STAR__16}
                />
            </div>
            {!!averageRating && (
                <span className="Rating__label">
                    {averageRating.toFixed(1)}
                </span>
            )}
            <span className="Rating__count" aria-hidden="true">
                {
                    <FormattedMessage
                        id="reviewCount"
                        defaultMessage="reviews"
                        values={{
                            REVIEWCOUNT: reviewCount
                        }}
                    >
                        {(txt: string): Node => `(${txt})`}
                    </FormattedMessage>
                }
            </span>
        </Fragment>
    );
};

export default ColorizedRating;
